import { WEBSITE_SETTINGS_DEFAULTS } from '../helper/websiteMeta';

function LoginIllustration({
    caption = `${WEBSITE_SETTINGS_DEFAULTS.systemTitle} — Admin Portal`,
}) {
    return (
        <div className="relative flex h-full w-full items-center justify-center px-10 py-12">
            <svg
                viewBox="0 0 420 380"
                className="w-full max-w-[360px]"
                aria-hidden
            >
                <circle cx="72" cy="88" r="28" fill="rgba(255,255,255,0.12)" />
                <path
                    d="M62 88h20M72 78v20"
                    stroke="#fff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    opacity="0.7"
                />

                <rect
                    x="300"
                    y="56"
                    width="56"
                    height="40"
                    rx="8"
                    fill="rgba(255,255,255,0.12)"
                />
                <path
                    d="M312 76h32M328 68v16"
                    stroke="#fff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    opacity="0.55"
                />

                <circle cx="340" cy="280" r="22" fill="#ffffff" />
                <path
                    d="M330 280l7 7 14-14"
                    stroke="#4569ab"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                />

                <rect x="88" y="118" width="244" height="168" rx="14" fill="#171A20" />
                <rect x="98" y="128" width="224" height="138" rx="8" fill="#ffffff" />

                <rect x="128" y="152" width="72" height="96" rx="6" fill="#eaf1ff" />
                <rect x="138" y="168" width="52" height="6" rx="3" fill="#4569ab" opacity="0.35" />
                <rect x="138" y="182" width="44" height="4" rx="2" fill="#4569ab" opacity="0.2" />
                <rect x="138" y="192" width="48" height="4" rx="2" fill="#4569ab" opacity="0.2" />
                <rect x="138" y="202" width="40" height="4" rx="2" fill="#4569ab" opacity="0.2" />
                <rect x="138" y="224" width="36" height="10" rx="4" fill="#f67a07" opacity="0.85" />

                <rect x="214" y="160" width="88" height="8" rx="4" fill="#4569ab" opacity="0.25" />
                <rect x="214" y="178" width="72" height="6" rx="3" fill="#4569ab" opacity="0.15" />
                <rect x="214" y="192" width="80" height="6" rx="3" fill="#4569ab" opacity="0.15" />
                <rect x="214" y="206" width="64" height="6" rx="3" fill="#4569ab" opacity="0.15" />

                <path d="M176 286h68v12c0 6-15 10-34 10s-34-4-34-10v-12z" fill="#171A20" />
                <rect x="156" y="298" width="108" height="10" rx="5" fill="#171A20" />

                <circle cx="210" cy="92" r="34" fill="#fff" />
                <path d="M186 98c6-14 28-14 34 0" fill="#171A20" />
                <circle cx="198" cy="88" r="3" fill="#171A20" />
                <circle cx="222" cy="88" r="3" fill="#171A20" />
                <path
                    d="M202 98c4 4 12 4 16 0"
                    stroke="#171A20"
                    strokeWidth="2"
                    strokeLinecap="round"
                    fill="none"
                />
                <path d="M176 118c8 18 60 18 68 0v18H176z" fill="#4569ab" />
                <path
                    d="M248 132c12 8 18 20 14 34"
                    stroke="#fff"
                    strokeWidth="10"
                    strokeLinecap="round"
                    fill="none"
                />
                <circle cx="258" cy="168" r="14" fill="#fff" />
                <path
                    d="M252 168l4 4 8-8"
                    stroke="#4569ab"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                />

                <path
                    d="M178 92c0-18 16-32 32-32s32 14 32 32"
                    stroke="#171A20"
                    strokeWidth="4"
                    fill="none"
                />
                <rect x="170" y="88" width="10" height="18" rx="5" fill="#171A20" />
                <rect x="240" y="88" width="10" height="18" rx="5" fill="#171A20" />

                <path
                    d="M96 320c24-12 48-12 72 0s48 12 72 0s48-12 72 0"
                    stroke="rgba(255,255,255,0.25)"
                    strokeWidth="2"
                    fill="none"
                    strokeLinecap="round"
                />
            </svg>

            <p className="absolute bottom-8 left-0 right-0 text-center text-sm text-white/70">
                {caption}
            </p>
        </div>
    );
}

export default LoginIllustration;
